import { HardwareCategory } from '@enmon/commons/lib/tools';
import type { DefaultOptionType } from 'antd/lib/select';

export const HARDWARE_FORM_ID = 'hardware-form' as const;

export const HARDWARE_CATEGORIES_TRANSLATED = {
  [HardwareCategory.ElectricityMeter]: 'Electricity meter',
  [HardwareCategory.GasMeter]: 'Gas meter',
  [HardwareCategory.WaterMeter]: 'Water meter',
  [HardwareCategory.HeatMeter]: 'Heat meter',
  [HardwareCategory.Module]: 'Module',
  [HardwareCategory.Sensor]: 'Sensor',
  [HardwareCategory.Splitter]: 'Splitter',
  [HardwareCategory.Other]: 'Other',
} as const;

export const hardwareCategoriesOptions: DefaultOptionType[] = Object.values(HardwareCategory).map(category => ({
  value: category,
  label: HARDWARE_CATEGORIES_TRANSLATED[category],
}));

export enum ModelLibraryTab {
  Manufacturer = 'manufacturer',
  Model = 'model',
  Module = 'module',
}

export const MODEL_LIBRARY_TABS_TRANSLATED: Record<ModelLibraryTab, string> = {
  [ModelLibraryTab.Manufacturer]: 'Manufacturers',
  [ModelLibraryTab.Model]: 'Meter models',
  [ModelLibraryTab.Module]: 'Meter modules',
} as const;

export enum MeterModelTab {
  Overview = 'overview',
  Meters = 'meters',
}

export const METER_MODEL_TABS_TRANSLATED: Record<MeterModelTab, string> = {
  [MeterModelTab.Overview]: 'Overview',
  [MeterModelTab.Meters]: 'Meters',
} as const;

/** Model library › Meter models › {current}: the middle crumb names the entity type and links to its list. */
export const modelLibraryBreadcrumbs = (tab: ModelLibraryTab, current?: string) => [
  { path: '/reseller-data/model-library', breadcrumbName: 'Model library' },
  { path: `/reseller-data/model-library/${tab}`, breadcrumbName: MODEL_LIBRARY_TABS_TRANSLATED[tab] },
  { path: '', breadcrumbName: current },
];
